import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TicketComments = ({ ticketId, getAuthHeader }) => {
  const [comments, setComments] = useState([]);
  const [search, setSearch] = useState("");
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  /* ---------------- LOAD COMMENTS ---------------- */
  const loadComments = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${ticketId}/comments`,
        { headers: getAuthHeader() }
      );

      // assuming API returns array
      setComments(res.data || []);
    } catch (err) {
      console.error("Failed to load comments", err);
      setComments([]);
    }
  };

  useEffect(() => {
    loadComments();
  }, [ticketId]);

  /* ---------------- ADD COMMENT ---------------- */
  const submitComment = async () => {
    if (!newComment.trim()) {
      toast.error("Comment cannot be empty");
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/comments`,
        { comment: newComment },
        { headers: getAuthHeader() }
      );

      toast.success("Comment added successfully");
      setNewComment("");
      loadComments();
    } catch (err) {
      console.error(err);
      toast.error("Failed to add comment");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- SEARCH FILTER ---------------- */
  const filteredComments = comments.filter((c) =>
    c.comment?.toLowerCase().includes(search.toLowerCase()) ||
    c.user_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <ToastContainer position="bottom-right" />

      {/* ---------------- ADD COMMENT CARD ---------------- */}
      <div className="card p-1 mb-3">
        <h5 className="mb-3">Comment</h5>

        <textarea
          rows={3}
          className="form-control mb-3"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Write your comment..."
        />

      <div className="text-end">
  {/* <button
    className="btn btn-sm btn-warning text-white px-3 btn-warning-no-hover"
    onClick={submitComment}
    disabled={loading}
  >
    {loading ? "Saving..." : "Save"}
  </button> */}

<button
  className="btn btn-danger"  onClick={submitComment}
  style={{ backgroundColor: "#dc3545" }}
>
  Save
</button>

</div>

      </div>

      {/* ---------------- SEARCH BAR ---------------- */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          Showing {filteredComments.length} of {comments.length} entries
        </div>

        <div>
          Search:{" "}
          <input
            className="form-control d-inline-block"
            style={{ width: 200 }}
            placeholder="Search comments..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* ---------------- COMMENTS TABLE ---------------- */}
      <div className="table-responsive">
        <table className="table table-striped">
          <tbody>
            {filteredComments.length === 0 && (
              <tr>
                <td>No comments found</td>
              </tr>
            )}

            {filteredComments.map((c) => (
              <tr key={c.id}>
                <td>
                  <div className="d-flex align-items-start">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                      alt="user"
                      width="40"
                      height="40"
                      className="rounded-circle me-3"
                    />
                    <div>
                      <b>{c.user_name}</b>{" "}
                      <small className="text-muted">
                        ({c.employee_id})
                      </small>
                      <br />
                      <span>{c.comment}</span>
                      <br />
                       <small className="text-muted">
  {new Date(c.created_at).toLocaleDateString("en-GB")}
</small>

                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ---------------- PAGINATION UI (STATIC) ---------------- */}
      <div className="d-flex justify-content-end">
        <button className="btn btn-light btn-sm me-2" disabled>
          Previous
        </button>
        <button className="btn btn-warning btn-sm text-white">
          1
        </button>
        <button className="btn btn-light btn-sm ms-2" disabled>
          Next
        </button>
      </div>
    </div>
  );
};

export default TicketComments;
